<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <button
          class="default-outline-btn text-black bg-transparent position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
          @click="exportExcel"
          v-if="current_permissions('export_transactions')"
        >
          {{ $t('reloadings.excel') }}
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_topup')"
        >
          {{ $t('reloadings.createRequest') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <!-- Barre de recherche -->
      <div class="row mb-15 mb-sm-20 mb-md-25">
        <div class="col-md-4">
          <div class="position-relative">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              :placeholder="$t('reloadings.search')"
            />
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('reloadings.code') }}
              </th>
              <th v-if="current_permissions('SUPERADMIN')" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('reloadings.organization') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('reloadings.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('reloadings.amount') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('reloadings.date') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('reloadings.attachedTo') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('reloadings.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(reloading) in reloadings" :key="reloading.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reloading.code }}
              </td>
              <td v-if="current_permissions('SUPERADMIN')" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reloading.organization.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reloading.description }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reloading.amount }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ formatDateFr(new Date(reloading.createdAt))}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ reloading.user?.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-info" v-if="reloading.status==='DRAFT'">{{ $t('reloadings.pending') }}</span>
                <span class="badge text-outline-success" v-if="reloading.status==='VALIDATED'">{{ $t('reloadings.validated') }}</span>
                <span class="badge text-outline-danger" v-if="reloading.status==='REJECTED'">{{ $t('reloadings.rejected') }}</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <!-- Le menu d'action est toujours visible : "Détails" fonctionne pour tous les statuts,
                     les actions Rejeter/Valider/Modifier restent réservées au statut DRAFT -->
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="showReloadingDetail(reloading)" data-bs-toggle="modal" data-bs-target="#detailModal">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('reloadings.details') }}</span>
                      </a>
                    </li>
                    <template v-if="reloading.status==='DRAFT'">
                      <li v-if="current_permissions('status_topup')">
                        <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" @click="changeStatus('REJECTED',reloading.code)">
                          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                          <span class="">{{ $t('reloadings.reject') }}</span>
                        </a>
                      </li>
                      <li v-if="current_permissions('status_topup')">
                        <a class="dropdown-item d-flex align-items-center" style="color: green;" href="javascript:void(0);" @click="changeStatus('VALIDATED',reloading.code)">
                          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                          <span class="">{{ $t('reloadings.validate') }}</span>
                        </a>
                      </li>
                      <li v-if="current_permissions('show_topup')">
                        <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" @click="showReloading(reloading.code)" data-bs-toggle="modal" data-bs-target="#companyModal">
                          <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                          <span class="">{{ $t('reloadings.edit') }}</span>
                        </a>
                      </li>
                    </template>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>pageSize" class="mb-0 text-paragraph">
          {{ $t('reloadings.showing') }} <span class="fw-bold">{{ showingFrom }}-{{ showingTo }}</span> {{ $t('reloadings.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('reloadings.results') }}
        </p>
        <p v-if="filteredTotal<=pageSize" class="mb-0 text-paragraph">
          {{ $t('reloadings.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('reloadings.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('reloadings.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Reloading -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('reloadings.reloadRequest') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('reloadings.amount') }}</label>
                  <div>
                    <input @keyup="handleAmountChange" v-model="formValues.amount" type="number" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" placeholder="2" @blur="validate('amount')" :class="{ 'is-invalid': errorsBis['amount'] }" />
                    <span class="invalid-feedback">{{ errorsBis['amount']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('reloadings.users') }}</label>
                  <select name="mode" id="mode" class="form-select fs-md-15 text-black shadow-none" @change="handleUserChange">
                    <option value="">{{ $t('reloadings.select') }}</option>
                    <option v-for="user in users" :value="user.code" :key="user.code"> {{ user.name }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('reloadings.description') }}</label>
                  <div>
                    <textarea v-model="formValues.description" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="$t('reloadings.descriptionPlaceholder')" @blur="validate('description')" @keyup="validate('description')" :class="{ 'is-invalid': errorsBis['description'] }">
                    </textarea>
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('reloadings.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal Détails du rechargement : qui a créé / qui a validé -->
  <div class="modal fade" id="detailModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('reloadings.details') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row mb-15">
            <div class="col-md-6">
              <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.code') }}</label>
              <p class="mb-0 text-black-emphasis">{{ detailReloading.code }}</p>
            </div>
            <div class="col-md-6">
              <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.amount') }}</label>
              <p class="mb-0 text-black-emphasis">{{ detailReloading.amount }}</p>
            </div>
          </div>

          <div class="row mb-15" v-if="detailReloading.description">
            <div class="col-md-12">
              <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.description') }}</label>
              <p class="mb-0 text-black-emphasis">{{ detailReloading.description }}</p>
            </div>
          </div>

          <hr />

          <!-- Créé par -->
          <div class="row mb-15">
            <div class="col-md-12">
              <h6 class="fw-bold mb-10">{{ $t('reloadings.createdBy') }}</h6>
            </div>
            <div class="col-md-6">
              <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.name') }}</label>
              <p class="mb-0 text-black-emphasis">{{ detailReloading.createdBy?.name || '-' }}</p>
            </div>
            <div class="col-md-6">
              <label class="d-block text-black fw-semibold mb-5">Email</label>
              <p class="mb-0 text-black-emphasis">{{ detailReloading.createdBy?.email || '-' }}</p>
            </div>
            <div class="col-md-6 mt-10">
              <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.date') }}</label>
              <p class="mb-0 text-black-emphasis">{{ detailReloading.createdAt ? formatDateFr(new Date(detailReloading.createdAt)) : '-' }}</p>
            </div>
          </div>

          <hr />

          <!-- Validé par -->
          <div class="row mb-15">
            <div class="col-md-12">
              <h6 class="fw-bold mb-10">{{ $t('reloadings.validatedBy') }}</h6>
            </div>
            <template v-if="detailReloading.validatedBy">
              <div class="col-md-6">
                <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.name') }}</label>
                <p class="mb-0 text-black-emphasis">{{ detailReloading.validatedBy?.name }}</p>
              </div>
              <div class="col-md-6">
                <label class="d-block text-black fw-semibold mb-5">Email</label>
                <p class="mb-0 text-black-emphasis">{{ detailReloading.validatedBy?.email }}</p>
              </div>
              <div class="col-md-6 mt-10">
                <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.date') }}</label>
                <p class="mb-0 text-black-emphasis">{{ detailReloading.validatedAt ? formatDateFr(new Date(detailReloading.validatedAt)) : '-' }}</p>
              </div>
            </template>
            <template v-else>
              <div class="col-md-12">
                <p class="mb-0 text-muted">{{ $t('reloadings.notValidatedYet') }}</p>
              </div>
            </template>
          </div>

          <div class="row" v-if="detailReloading.status">
            <div class="col-md-12">
              <label class="d-block text-black fw-semibold mb-5">{{ $t('reloadings.status') }}</label>
              <span class="badge text-outline-info" v-if="detailReloading.status==='DRAFT'">{{ $t('reloadings.pending') }}</span>
              <span class="badge text-outline-success" v-if="detailReloading.status==='VALIDATED'">{{ $t('reloadings.validated') }}</span>
              <span class="badge text-outline-danger" v-if="detailReloading.status==='REJECTED'">{{ $t('reloadings.rejected') }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('reloadings.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../router/index'
import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import { Country, Fee, Operator, Organization, TypeFree, Reloading, User } from "@/utils/Model";
import { current_permissions } from '../../utils/permission';
import { checkSessionValidate } from '../../utils/function';

const backApi = inject('back');
const { locale, t } = useI18n();

const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedType = ref('');
const selectedMode = ref('');
const selectedUser = ref('');
const users = ref(new Array<User>());

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

const countries = ref(new Array<Country>());
let edit = 0;
let itemCode = '';
let selectedOrganization = '';
let user = {} as User;
const operators = ref(new Array<Operator>());
const collectBalance = ref(0);
let balance: number = 0;
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();
let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'amount': '', 'description': '' };
const pageLoad = ref(false);

const formValues = reactive({
  amount: "",
  description: ""
});

const detailReloading = ref<any>({});

const schema = yup.object({
  amount: yup.number().required('Le montant est requis'),
  description: yup.string().required('La description est requise'),
});

const allReloadings = ref<any[]>([]);

const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

const statusLabelOf = (status: string) =>
  status === 'DRAFT' ? t('reloadings.pending')
    : status === 'VALIDATED' ? t('reloadings.validated')
    : status === 'REJECTED' ? t('reloadings.rejected')
    : '';

const filteredReloadings = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allReloadings.value;
  return allReloadings.value.filter((r: any) => {
    const values = [
      r.code,
      r.description,
      r.amount,
      r.createdAt ? formatDateFr(new Date(r.createdAt)) : '',
      r.user?.name,
      r.organization?.name,
      statusLabelOf(r.status),
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredReloadings.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const reloadings = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredReloadings.value.slice(start, start + pageSize.value);
});

function handleAmountChange(event) {
  let withdrawAmount = event.target.value;
  if (parseFloat(withdrawAmount) <= 0) {
    formValues.amount = ''
  }
}

function handleTypeChange(event) {
  selectedType.value = event.target.value;
}
function handleUserChange(event) {
  selectedUser.value = event.target.value;
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

const initField = () => {
  formValues.amount = '';
  formValues.description = '';
  itemCode = '';
  selectedOrganization = '';
  edit = 0;
}

const showReloadingDetail = (reloading) => {
  detailReloading.value = reloading;
}

const getUsers = (code) => {
  axios.get(`${backApi}/secure/users/?organization=${code}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      users.value = response.data;
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const fetchReloadingsPage = (targetPage: number) => {
  let baseUrl = '';
  if (
    role === 'SUPERADMIN' ||
    role === 'BUSINESS' ||
    role === 'SUPPORT'
  ) {
    baseUrl = `${backApi}/secure/topups/extended`;
  } else {
    baseUrl = `${backApi}/secure/topups/`;
    //baseUrl = `${backApi}/secure/topups/?organization=${codeOrganization}`;
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const loadAllReloadings = async () => {
  try {
    const first = await fetchReloadingsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchReloadingsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allReloadings.value = collected;
    data = collected; 
    page.value = 1;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

// Revenir à la page 1 à chaque nouvelle recherche.
watch(searchQuery, () => {
  page.value = 1;
});

const showReloading = (code) => {
  axios.get(backApi + '/secure/topups/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.amount = response.data.amount;
      formValues.description = response.data.description;
      itemCode = response.data.code;
      selectedOrganization = response.data.organization.code;
      edit = 1;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

const getBalanceCollect = () => {
  axios.post(backApi + `/secure/accounts/balance/available`, {
    code: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      collectBalance.value = response.data.availableBalance;
      balance = response.data.availableBalance;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/topups/status`, {
    code: code,
    status: status
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const save = () => {
  if (edit == 0) {
    storeReloading()
  } else {
    updateReloading()
  }
}

const storeReloading = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/topups/new`, {
      amount: parseFloat(formValues.amount),
      description: formValues.description,
      organization: codeOrganization,
      user: (selectedUser.value == '') ? null : selectedUser.value,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

const updateReloading = () => {
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/topups/${itemCode}/edit`, {
      amount: parseFloat(formValues.amount),
      description: formValues.description,
      code: itemCode,
      organization: selectedOrganization
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      edit = 0;
      itemCode = '';
      selectedOrganization = '';
      if (response.status === 200) {
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const exportExcel = () => {
  import("../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE RECHARGEMENT", "DESCRIPTION", "MONTANT", "DATE", "STATUT"];
    const Fields = ["code", "description", "amount", "createdAt", "status"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "rechargement",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData, JsonData) {
  return JsonData.map((v) => FilterData.map(j => {
    return v[j];
  }));
}

onMounted(async () => {
  checkSessionValidate(1)
  loadAllReloadings();
  getBalanceCollect();
  getUsers(codeOrganization);

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});
</script>